import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Vendors from './Vendor1';
import Categories from './Categories';
import Users from './Users';
import VendorDetails from './VendorDetails';
import PendingAdmins from './PendingAdmins';
import ActiveOrders from './ActiveOrders';
import AdminOrdersManagement from './AdminOrdersManagement';
import RegisterDriver from './RegisterDriver';
import DriversList from './DriversList';
import VendorDriverRequests from './VendorDriverRequests';
import OrderStats from './OrderStats';
import AllProducts from './AllProducts';
import SliderManagement from '../components/SliderManagement';
import NotificationBell from '../components/NotificationBell';
import Coupons from './Coupons';
import BundleDeals from './BundleDeals';
import DeliveryZones from './DeliveryZones';
import DeliveryConfig from './DeliveryConfig';
import AppVersions from './AppVersions';

function Dashboard() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    // Check if screen size is mobile
    useEffect(() => {
        const checkScreenSize = () => {
            setIsMobile(window.innerWidth < 768);
            // Start with sidebar closed for both mobile and desktop to maximize space
            if (!sidebarOpen) {
                setSidebarOpen(false);
            }
        };

        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <div className="d-flex flex-column" style={{ direction: 'rtl' }}>
            {/* Top Navbar */}
            <nav className="navbar navbar-expand-lg navbar-light bg-white border-bottom shadow-sm position-fixed w-100" style={{ zIndex: 1030, top: 0 }}>
                <div className="container-fluid">
                    {/* Menu Button on the Left */}
                    <button
                        className="btn btn-outline-primary me-3"
                        style={{ 
                            border: 'none',
                            borderRadius: '5px',
                            padding: '8px 12px'
                        }}
                        onClick={toggleSidebar}
                    >
                        ☰
                    </button>
                    
                    {/* Brand/Title */}
                    <span className="navbar-brand mb-0 h1 text-primary">
                        لوحة التحكم الإدارية
                    </span>
                    
                    {/* Right side items (can add user profile, notifications, etc.) */}
                    <div className="navbar-nav ms-auto">
                        <NotificationBell />
                    </div>
                </div>
            </nav>

            {/* Main Content Area */}
            <div className="d-flex" style={{ marginTop: '56px' }}> {/* Offset for fixed navbar */}

            {/* Overlay for mobile when sidebar is open */}
            {isMobile && sidebarOpen && (
                <div
                    className="position-fixed w-100 h-100"
                    style={{
                        top: 0,
                        left: 0,
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        zIndex: 1040
                    }}
                    onClick={toggleSidebar}
                />
            )}

            <Sidebar 
                isOpen={sidebarOpen} 
                isMobile={isMobile} 
                onClose={() => setSidebarOpen(false)} 
            />
            
            <div 
                className="flex-grow-1 p-4 bg-light" 
                style={{ 
                    minHeight: '100vh',
                    marginRight: sidebarOpen ? '240px' : '0', // Simplified margin logic
                    transition: 'margin-right 0.3s ease',
                    paddingTop: '20px' // Consistent padding now that navbar handles spacing
                }}
            >
                <Routes>
                    <Route path="vendors" element={<Vendors />} />
                    <Route path="vendors/:id" element={<VendorDetails />} />
                    <Route path="categories" element={<Categories />} />
                    <Route path="users" element={<Users />} />
                    <Route path="pending-admins" element={<PendingAdmins />} />
                    <Route path="active-orders" element={<ActiveOrders />} />
                    <Route path="admin-orders" element={<AdminOrdersManagement />} />
                    <Route path="register-driver" element={<RegisterDriver />} />
                    <Route path="drivers-list" element={<DriversList />} />
                    <Route path="driver-requests" element={<VendorDriverRequests />} />
                    <Route path="order-stats" element={<OrderStats />} />
                    <Route path="all-products" element={<AllProducts />} />
                    <Route path="coupons" element={<Coupons />} />
                    <Route path="bundle-deals" element={<BundleDeals />} />
                    <Route path="delivery-zones" element={<DeliveryZones />} />
                    <Route path="slider-management" element={<SliderManagement />} />
                    <Route path="delivery-config" element={<DeliveryConfig />} />
                    <Route path="app-versions" element={<AppVersions />} />
                    <Route path="delivery-config" element={<DeliveryConfig />} />
                    <Route path="app-versions" element={<AppVersions />} />
                </Routes>
            </div>
            </div>
        </div>
    );
}

export default Dashboard;
